import { render, staticRenderFns } from "./CreateEditFormularioDePesquisa.vue?vue&type=template&id=46d8cf4c&"
import script from "./CreateEditFormularioDePesquisa.vue?vue&type=script&lang=js&"
export * from "./CreateEditFormularioDePesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports